import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Check } from '@mui/icons-material';
import SimpleCard from '../../../../../components/SimpleCard';
import { AMENITY_SPACE_STATUS } from '../../../../../constants/event-application-status';

// eslint-disable-next-line react/prop-types
export default function AboutYourVenue({ venue, event, surcharges, freeFeatures }) {
  const getStreetAddress = () => {
    const businessAddress = event?.street_address ? ` ${event.street_address}` : '';
    const city = event?.city ? `, ${event.city.name}` : '';
    const state = event?.state ? `, ${event.state.name}` : '';
    return <b>{`${businessAddress + city + state}`}</b>;
  };

  return (
    <Grid container>
      <Grid item xs={12} md={2}>
        <Typography variant="h6" fontWeight="bold">
          About your venue:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography
          variant="h5"
          color="#EE7B57"
          textAlign="center"
          fontWeight="bold"
          style={{ textTransform: 'uppercase' }}>
          {venue?.name}
        </Typography>
        <Typography variant="h6" textAlign="center">
          This venue is located at {getStreetAddress()}
        </Typography>
        <SimpleCard>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Typography variant="h7" fontWeight="bold">
                Venue features:
              </Typography>
              <Grid container marginTop={2}>
                {freeFeatures?.map((item) => (
                  <Grid item key={item.id} marginTop={2} margin={1.3}>
                    <img style={{ width: 30 }} src={item.Icon} alt={item.name} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item md>
              <Typography variant="h7" fontWeight="bold">
                Additional features:
              </Typography>
              {surcharges?.length > 0 ? (
                <Grid container paddingY={2}>
                  {surcharges?.map(
                    (i) =>
                      i.status === AMENITY_SPACE_STATUS.ENABLED && (
                        <Grid item md={6} key={i.id}>
                          <Check />
                          <span>{i.name}</span>
                        </Grid>
                      ),
                  )}
                </Grid>
              ) : (
                <Grid container paddingY={2}>
                  <Typography variant="body2">Without additional features...</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </SimpleCard>
      </Grid>
    </Grid>
  );
}

AboutYourVenue.defaultProps = {
  surcharges: [],
  freeFeatures: [],
};

AboutYourVenue.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types, react/no-unused-prop-types
  freeFeatures: PropTypes.any,
  venue: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  event: PropTypes.shape({
    street_address: PropTypes.string.isRequired,
    city: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    state: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
  surcharges: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  ),
};
